import React, { useState, useEffect } from 'react';

import axios from 'axios';

import { styled } from '@mui/material/styles';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

import HeadLine2 from './HeadLine2.js'
import StandardBox from './StandardBox.js'

const CustomedSelect = styled(Select)({
  marginLeft: 8,
  backgroundColor: "#FFFFFF"
});

export default function PicSelect2(props) {

  const { token, employeeCode, handleEmployeeCode } = props;

  const [employeeList, setEmployeeList] = useState([]);

  useEffect(() => {

    const apiURL = process.env.REACT_APP_BASEURL;
    const employeeListURL = `${apiURL}/data_send/employee_list`;

    let lists = []

    axios({
      method: "GET",
      url:employeeListURL,
      headers: {
        Authorization: 'Bearer ' + token
      }
    })
      .then(
        response => {

          response.data.rows.forEach((res) => {

            // console.log(res);
            lists.push({
              employeeCode: res['employee_code'],
              employeeName: res['last_name'] + res['first_name'],
            })
          });

          setEmployeeList(lists);
        }
      );

  }, [token])


  return (
    <>
      <FormControl
        sx={{
          width: 200,
          backgroundColor: "#FFFFFF",
          // mb: 2
        }}
      >
        <InputLabel id="demo-multiple-checkbox-label">担当者</InputLabel>
        <CustomedSelect
          labelId="prefecture"
          id="prefecture"
          label="都道府県名"
          value={employeeCode}
          onChange={handleEmployeeCode}
        >
          <MenuItem key={''} value={''}>選択なし</MenuItem>
          {employeeList.map((employee) => (
            <MenuItem key={employee['employeeCode']} value={employee['employeeCode']}>
              {employee['employeeName']}
            </MenuItem>
          ))}
        </CustomedSelect>
      </FormControl>

    </>
  )
}